import axios from "axios";
import i18n from "../i18n";
import { BackendUrls } from "./backend-urls";
import { tokenService } from ".";

export const BASE_URL =
  !import.meta.env.REACT_APP_ENV || import.meta.env.REACT_APP_ENV === "development"
    ? BackendUrls.DEV_API_URL
    : BackendUrls.PROD_API_URL;

export const ApiWithToken = axios.create({
  baseURL: BASE_URL + i18n.language,
});

export const ApiWithoutToken = axios.create({
  baseURL: BASE_URL + i18n.language,
});

ApiWithToken.interceptors.request.use(
  (config) => {
    const accessToken = tokenService.getTokenFromLC("access");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

ApiWithToken.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response.status !== 401) {
      return Promise.reject(error);
    }
    try {
      const originalRequest = error.config;
      await tokenService.refreshTokens();
      return ApiWithToken(originalRequest);
    } catch {
      window.location.href = "/";
      tokenService.removeTokens();
      return Promise.reject(error);
    }
  }
);
